import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    book_list: [],
    char_list: [],
    rachiyta_list: [],
    kirtan_list: [],
    bhav_list: [],
    content_kirtan_list: [],
};

export const FormListSlice = createSlice({
    name: "FormList",
    initialState,
    reducers: {
        setBookList: (state, action) => {
            state.book_list = action.payload;
        },
        setCharList: (state, action) => {
            state.char_list = action.payload;
        },
        serRachiytaList: (state, action) => {
            state.rachiyta_list = action.payload;
        },
        setKirtanList: (state, action) => {
            state.kirtan_list = action.payload;
        },
        setBhavList: (state, action) => {
            state.bhav_list = action.payload;
        },
        setContentKirtanList: (state, action) => {
            state.content_kirtan_list = action.payload;
        }
    },
});

export const {
    setBookList,
    setCharList,
    serRachiytaList,
    setKirtanList,
    setBhavList,
    setContentKirtanList
} = FormListSlice.actions;

export default FormListSlice.reducer; 